import React, { FC } from 'react';

interface IProp {
  width?: number;
  height?: number;
  fill?: string;
  opacity?: number;
}

const IconHisting: FC<IProp> = ({ width = 23, height = 23, fill = 'white', opacity }) => {
  return (
    <svg
      style={{
        display: 'inline',
        width: `${width}px`,
        height: `${height}px`,
      }}
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3379 1.15039C12.4634 1.15041 12.5555 1.19052 12.6035 1.22852C12.6131 1.23607 12.6181 1.24468 12.623 1.25L12.6123 1.2666L12.5957 1.2959L8.93555 7.6875L8.24316 8.89746L9.61523 8.65039L17.3828 7.24707L17.4043 7.24316L17.4258 7.23828C17.4638 7.22873 17.5068 7.22268 17.5537 7.22266C17.6793 7.22266 17.7712 7.26368 17.8193 7.30176C17.8283 7.30887 17.833 7.31713 17.8379 7.32227C17.837 7.32323 17.837 7.32514 17.8359 7.32617L17.4131 7.74805L17.4199 7.75684L5.82129 19.7549L5.79785 19.7734C5.74721 19.8118 5.65708 19.8496 5.53711 19.8496C5.41144 19.8496 5.31962 19.8086 5.27148 19.7705C5.2615 19.7626 5.25599 19.7545 5.25098 19.749L5.27148 19.7236L5.29395 19.6875L9.75 12.2715L10.4512 11.1055L9.10352 11.293L1.64355 12.3301L1.6084 12.335L1.57422 12.3438C1.53263 12.3542 1.48983 12.3603 1.44629 12.3604C1.32069 12.3604 1.2288 12.3194 1.18066 12.2812C1.17073 12.2734 1.16519 12.2652 1.16016 12.2598L1.16699 12.2529L12.0488 1.24707L12.0771 1.22559C12.1268 1.1881 12.217 1.15047 12.3379 1.15039Z"
        stroke={fill}
        strokeWidth="1.3"
      />
    </svg>
  );
};

export default IconHisting;
